import { cn } from '@/lib/utils'
import { memo } from 'react'

const Table = ({
  headerPosition,
  table,
  rows,
  layout
}: {
  headerPosition: 'top' | 'left' | 'none'
  table: { rows: Array<Array<string>> }
  rows: Array<Array<string>>
  layout: string
}) => (
  <table
    className={cn(
      'mt-md textstyle-md-regular w-full table-auto bg-neutral-200 text-neutral-600'
    )}
  >
    {headerPosition === 'top' && (
      <thead>
        <tr className={cn('border-b-4 border-b-white p-4 py-4')}>
          {table?.rows[0]?.map((column: string, colIndex: number) => (
            <th
              key={colIndex?.toString()}
              className={cn(
                'p-xs textstyle-md-bold h-full bg-neutral-500 text-left text-neutral-100'
              )}
            >
              <div
                className="rich-text whitespace-nowrap"
                dangerouslySetInnerHTML={{ __html: column }}
              />
            </th>
          ))}
        </tr>
      </thead>
    )}
    <tbody>
      {rows?.map((row, index) => (
        <tr
          className={cn('border-b-4 border-b-white p-4 py-4')}
          key={index?.toString()}
        >
          {row?.map((column: string, colIndex: number) => {
            let classes = ''

            if (layout === 'col-30-70') {
              classes = colIndex === 0 ? 'w-[30%]' : 'w-[70%]'
            } else if (layout === 'col-40-30-30') {
              classes = colIndex === 0 ? 'w-[40%]' : 'w-[30%]'
            } else if (layout === 'col-40-30c-30c') {
              classes = colIndex === 0 ? 'w-[40%]' : 'w-[30%]'
            } else if (layout === 'col-40-20-20-20') {
              classes = colIndex === 0 ? 'w-[40%]' : 'w-[20%]'
            } else if (layout === 'col-40-20c-20c-20c') {
              classes = colIndex === 0 ? 'w-[40%]' : 'w-[20%]'
            } else if (layout === 'col-20-20-20-20-20') {
              classes = colIndex === 0 ? 'w-[20%]' : 'w-[20%]'
            }

            return headerPosition === 'left' && colIndex === 0 ? (
              <th
                key={'th-text-' + colIndex?.toString()}
                className={cn(
                  classes,
                  'p-xs textstyle-md-bold h-full bg-neutral-500 text-left text-neutral-100'
                )}
              >
                <div
                  className="rich-text"
                  dangerouslySetInnerHTML={{ __html: column }}
                />
              </th>
            ) : (
              <td
                className={cn(classes, 'p-xs h-full')}
                key={'td-text-' + colIndex?.toString()}
              >
                <div
                  className="rich-text"
                  dangerouslySetInnerHTML={{ __html: column }}
                />
              </td>
            )
          })}
        </tr>
      ))}
    </tbody>
  </table>
)

export default memo(Table)
